import React from "react";
import { connect } from "react-redux";
import moment from "moment";
import { newSeasonFilterStyle, periodFilterStyle, yearsFilterStyle } from "../../../services/utils";
import ReactSelect, { components } from "react-select";
import { setEventStatsYear } from "../../../actions/actions/eventStats";


const DropdownIndicator = props => {
  return (
    <components.DropdownIndicator {...props}>
      <img src={"/img/icons/Polygon.svg"} className={'mr-1'} />
    </components.DropdownIndicator>
  );
};

const PeriodFilterCotisation = ({ yearsOptions, onChangePeriod }) => {

  // handleSelectChange = (value) => {
  //   let selectedYears = value.map(year => '' + year.value);
  //   setEventStatsYear(selectedYears);
  // }

  const handleSelectChange = (value) => {
    let selectedYear = value.value;
    onChangePeriod(selectedYear);
  };

  const currentYear = moment().year();
  const options = yearsOptions ? yearsOptions : [
    { value: (currentYear + 1), label: (currentYear + 1) },
    { value: (currentYear), label: (currentYear) },
    { value: (currentYear - 1), label: (currentYear - 1) },
    { value: (currentYear - 2), label: (currentYear - 2) },
    { value: (currentYear - 3), label: (currentYear - 3) }
  ];

  const defaultYearOption = options.find(
    (opt) => opt.value === currentYear
  );

  return (
    /*<ReactSelect
      className="my-2 mx-4 event-small-filter"
      onChange={handleSelectChange}
      styles={periodFilterStyle()}
      defaultValue={{value: (moment().format('YYYY')), label: (moment().format('YYYY'))}}
      options={yearsOptions}
      components={{ DropdownIndicator, IndicatorSeparator:() => null, Input:() => null}}
    />*/
    // <ReactSelect
    //   onChange={handleSelectChange}
    //   isClearable={false}
    //   isMulti
    //   styles={yearsFilterStyle()}
    //   defaultValue={defaultYearOption ? [defaultYearOption] : []}
    //   options={yearsOptions}
    //   components={{ DropdownIndicator, IndicatorSeparator: () => null, Input: () => null, Placeholder: () => null }}
    // />
    <ReactSelect
      onChange={handleSelectChange}
      styles={newSeasonFilterStyle()}
      defaultValue={defaultYearOption ? defaultYearOption : null}
      options={options}
      components={{ DropdownIndicator, IndicatorSeparator: () => null, Input: () => null }}
    />
  );
};

const mapStateToProps = state => ({});

const mapDispatchToProps = {
  setEventStatsYear,
};

export default connect(mapStateToProps, mapDispatchToProps)(PeriodFilterCotisation);



// WEBPACK FOOTER //
// ./app/components/Filters/EventStats/PeriodFilterCotisation.js